import { ToastManagerStore } from "@core/presentacion/component/feedback/toast-manager/toast-manager.store";
import i18n from "@i18n";
import { ProjectKanbanBlockRepository } from "@project/data/repositories/project-kanban-block.repository";
import { ProjectKanbanBlock } from "@project/domain/models/project-kanban-block.model";
import { inject, injectable } from "inversify";

@injectable()
export class EditProjectKanbanBlockUseCase {
    constructor(
        @inject(ProjectKanbanBlockRepository)
        private readonly repository: ProjectKanbanBlockRepository,
    ) {}

    async execute(
        id: number,
        body: {
            name?: string;
            phase?: string;
            is_active?: boolean;
        },
    ): Promise<ProjectKanbanBlock | null> {
        const result = await this.repository.update(id, body);

        if (result.isLeft()) {
            ToastManagerStore.error(
                i18n.t("component:toastManager.defaultError"),
            );
            return null;
        }

        return result.getOrThrow();
    }
}
